<template>
  <section class="victory">
    <div class="victory__media" aria-hidden="true" />
    <div class="victory__card">
      <div class="victory__bento">
        <div class="victory__text">
          <h2 class="victory__title">Готовы принять вызов</h2>
          <p class="victory__subtitle">
            Подайте заявку, переходите на&nbsp;сайт CASE-IN&nbsp;&reg;,
            создавайте личный кабинет и&nbsp;становитесь участником
          </p>
        </div>
        <div class="victory__action">
          <p class="victory__deadline">
            <img
              class="victory__deadline-icon"
              :src="iconCalendar"
              alt=""
              width="32"
              height="32"
            />
            <span
              >Регистрация с&nbsp;24.09.2026&nbsp;г.
              до&nbsp;14.10.2026&nbsp;г.</span
            >
          </p>
          <Button type="white" :to="REGISTRATION_URL">подать заявку</Button>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import Button from "@/components/Button.vue";
import { REGISTRATION_URL } from "@/constants";
// Графика (узел IMG_02 — вышки и кольца одним слоем) подставляется фоном
// в стилях, см. .victory__media: это декор, отдельный <img> ему не нужен.
import iconCalendar from "@/assets/case-championship/icon-calendar.svg";
</script>

<style lang="scss" scoped>
.victory {
  display: flex;
  flex-direction: column;
  // В макете графика идёт во всю ширину блока от самого верха, а карточка
  // лежит с отступом 8px по бокам и снизу (см. &__card).
  padding: 0;
  border-radius: var(--radiusOuter);
  overflow: clip;
  background: #f2f2f2;

  // Десктопная раскладка — строго выше 1180: на планшетной ширине графика
  // занимала половину блока и обрезалась по бокам.
  @include above-banner {
    flex-direction: row;
    align-items: stretch;
    gap: 16px;
    padding: 0;
  }

  &__media {
    position: relative;
    width: 100%;
    // Экспорт 486×224 с полями по бокам полотна: высота фиксирована, поэтому
    // графика везде одного размера, а на узком экране режутся только поля.
    height: 224px;
    background-image: image-set(
      url("@/assets/case-championship/victory-mobile.webp") 1x,
      url("@/assets/case-championship/victory-mobile@2x.webp") 2x
    );
    background-repeat: no-repeat;
    background-position: center;
    // Экспорт с прозрачностью: фон секции просвечивает.
    background-size: auto 100%;

    // На планшетной ширине графика чуть крупнее мобильной.
    @include md {
      height: 240px;
    }

    @include above-banner {
      order: 2;
      // В макете графика занимает ровно 632px — размер экспорта 632×306.
      flex: 0 1 632px;
      min-width: 1px;
      width: auto;
      height: auto;
      background-image: image-set(
        url("@/assets/case-championship/victory-desktop.webp") 1x,
        url("@/assets/case-championship/victory-desktop@2x.webp") 2x
      );
    }
  }

  &__card {
    // В макете карточка не прижата к краям: 8px по бокам и снизу.
    margin: 0 8px 8px;

    @include above-banner {
      margin: 0;
      order: 1;
      // В макете контейнер — 648px, а внутренний отступ задан только слева и
      // по вертикали: чёрная карточка выходит на 624px и прижимается к графике
      // (между ними остаётся gap 16px). При нехватке ширины обе половины
      // сжимаются пропорционально.
      flex: 0 1 648px;
      max-width: 648px;
      min-width: 1px;
      padding: 24px 0 24px 24px;
      display: flex;
      flex-direction: column;
    }
  }

  &__bento {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 12px;
    background: var(--colorBlack);
    border-radius: var(--radiusInner);

    @include above-banner {
      flex: 1 0 0;
      justify-content: space-between;
      padding: 24px;
    }
  }

  &__text {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  &__title {
    color: var(--colorWhite);
    font-size: var(--sizeHeading2);
    line-height: 26px;

    @include above-banner {
      line-height: 30px;
    }
  }

  &__subtitle {
    color: var(--colorWhite);
    font-size: var(--sizeText);
    line-height: var(--lineHeightText);
  }

  &__action {
    display: flex;
    flex-direction: column;
    gap: 12px;

    @include above-banner {
      gap: 16px;
      // В макете кнопка не на всю ширину карточки (253px при контенте 576px),
      // а по ширине строки с датой регистрации.
      align-self: flex-start;
    }
  }

  &__deadline {
    display: flex;
    align-items: center;
    gap: 6px;
    color: var(--colorWhite);
    font-size: var(--sizeText);
    line-height: var(--lineHeightText);
  }

  &__deadline-icon {
    flex-shrink: 0;
  }
}
</style>
